module.exports = __webpack_public_path__ + "static/media/logo.f59eff14.png";